import { create } from 'zustand'

type DriverRechargeMetricsState = {
    resetSelectedTagAmount: () => void
    selectedTagAmount: null | number
    setSelectedTagAmount: (amount: null | number) => void
}

export const useDriverRechargeMetricsStore = create<DriverRechargeMetricsState>((set) => ({
    selectedTagAmount: null,
    setSelectedTagAmount: (amount) => set({ selectedTagAmount: amount }),
    resetSelectedTagAmount: () => set({ selectedTagAmount: null }),
}))
